import { IComboBox, IComboBoxOption, ComboBox, IconButton } from '@fluentui/react';
import React from 'react';
import { CallableFn } from './CustomInput';
import CustomInputIfc from './CustomInputIfc';
import { useTranslation, Trans } from 'react-i18next';
import ErrorListForInput from './ErrorListForInput';

interface IComboBoxInput {
  input: CustomInputIfc;
  onChangeExtended?: (input: CustomInputIfc) => void;
  onBlur: (input: CustomInputIfc) => void;
  label: string;
  options: IComboBoxOption[];
  clearAfterSelection?: boolean;
  getItemFromKey?: (key: string | number) => any;
  selectedKey?: string | null;
  executeRefresh?: boolean;
  disabled?: boolean;
  onDelete?: () => void;
}

export const ComboBoxInput = (props: IComboBoxInput) => {
  const { t, i18n } = useTranslation();
  const [updateFlag, setUpdateFlag] = React.useState(false);
  // const [selectedKey, setSelectedKey] = React.useState<string | number | undefined>(
  //   props.selectedKey ? props.selectedKey : undefined
  // );
  // const [options, setOptions] = React.useState(props.options);
  const [textDropDown, setTextDropdown] = React.useState<string>(
    props.options.find((o) => o.key === props.input.getValue())?.text || ''
  );

  const [optionsFiltered, setOptionsFiltered] = React.useState(props.options);

  React.useEffect(() => {
    setOptionsFiltered(props.options);
  }, [props.options]);

  const getOptionFromKey = (): IComboBoxOption | undefined => {
    const opt = props.options.find((o) => o.key == props.input.getValue());
    return opt;
  };

  const updateViewAfterDoing = (anAction: CallableFn) => {
    setUpdateFlag((u) => {
      anAction();
      return !u;
    });
  };

  const onBlurCustomInput = () => {
    const t = props.options.find((o) => o.key == props.input.getValue());
    if (t) setTextDropdown(t.text);
    // setOptions(props.options);
    // setOptionsFiltered(props.options);
    updateViewAfterDoing(() => {
      props.input.onBlur();
      props.onBlur(props.input);
    });
  };

  const onInputValueChange = (value: string) => {
    setTextDropdown(value);
    // setOptions(props.options.filter((op) => op.text.toLocaleLowerCase().includes(value.toLocaleLowerCase())));
    let _optionsFiltered = [...props.options];
    let save = _optionsFiltered.filter((opt) =>
      opt.text.toLocaleLowerCase().includes(value.toLocaleLowerCase())
    );
    setOptionsFiltered(save);
  };

  React.useEffect(() => {
    // setOptions(props.options);
    // const opt = props.options.find((o) => o.key === props.selectedKey);
    // setTextDropdown(opt ? opt.text : '');
  }, [props.options]);

  const onChangeCustomInput = (
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption,
    index?: number,
    value?: string
  ) => {
    if (option) {
      let key = option.key;
      updateViewAfterDoing(() => {
        props.input.setValue(props.getItemFromKey ? props.getItemFromKey(key!) : option!.key);
      });
      if (props.onChangeExtended) {
        props.onChangeExtended(props.input);
      }
      setTextDropdown(option.text);
      // setSelectedKey(key);
      setOptionsFiltered(props.options);
      if (props.clearAfterSelection) {
        setTextDropdown('');
      }
    }
  };

  React.useEffect(() => {
    // if (props.selectedKey && selectedKey !== props.selectedKey) {
    //   setSelectedKey(props.selectedKey);
    const opt = getOptionFromKey();
    if (opt) {
      setTextDropdown(opt.text);
    }
    // }

    // if (!props.selectedKey && selectedKey !== props.selectedKey) {
    //   console.log('clear');
    //   setTextDropdown('');
    //   setSelectedKey(undefined);
    // }
    // }, [props.selectedKey, selectedKey, props.options]);
  }, [props.options]);

  React.useEffect(() => {
    if (!props.input.getValue()) {
      setTextDropdown('');
    } else {
      const opt = getOptionFromKey();
      if (opt) {
        setTextDropdown(opt.text);
      }
    }
  }, [props.input.getValue()]);

  return (
    <div className="combo-container">
      {props.onDelete && (
        <IconButton
          iconProps={{ iconName: 'Cancel' }}
          onClick={props.onDelete}
          style={{
            position: 'absolute',
            zIndex: 1,
            height: 25,
            bottom: '4px',
            right: '40px',
            color: '#f74747',
          }}
        />
      )}
      <ComboBox
        // selectedKey={selectedKey}
        selectedKey={props.input.getValue()}
        label={t(props.label)}
        text={textDropDown}
        autoComplete="off"
        allowFreeform
        openOnKeyboardFocus={true}
        // options={options ? options : []}
        styles={{
          input: { width: props.onDelete ? '90%' : '100%', marginRight: props.onDelete ? '10%' : '0%' },
        }}
        options={optionsFiltered}
        onInputValueChange={onInputValueChange}
        onChange={onChangeCustomInput}
        onBlur={(ev) => onBlurCustomInput()}
        disabled={props.disabled}
      />
      {props.input.hasErrors() && <ErrorListForInput customInput={props.input} />}
    </div>
  );
};

export default ComboBoxInput;
